import EthereumTransaction from "decentralized/transactions/EthereumTransaction.js";
import BackendQuery from "decentralized/BackendQuery.js";
import {setMintedTokens} from 'actions/index.js';
import {set_seed, value} from './random.js';
import {NewTokenSeed, NewCreatorProject} from "decentralized/EthereumEvents.js"
import {ethers} from 'ethers';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {NFT} from 'decentralized/transactions/contracts.js';
import NFTContract from "decentralized/contracts/NFTContract.js";
import {PUBLIC, PRIVATE, GUILD} from 'constants/save-sequence-options.js';

export const mintNewProject = async (engine, title, maxInvocations=10, priceInWei=1200) => {
    let contentHash = await engine.save(title, PUBLIC, false);

    let args = [
        ipfsHashToBytes32(contentHash),
        title,
        maxInvocations,
        true,
        1800000000
        ];

    if (window.ethereum) {
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        // Prompt user for account connections
        await provider.send("eth_requestAccounts", []);
        const signer = provider.getSigner();
        let {contractAddress, abi} = new NFTContract();
        const zcontract = new ethers.Contract(contractAddress, abi, signer);
        await zcontract.newProject(...args);
    }
};

export const getMintedProjects = async () => {
    let projects = await new BackendQuery(new NFTContract().contractAddress)
        .from(NewCreatorProject)
        .select("projectId")
        .select("title")
        .executeQuery();

    let mints = await new BackendQuery(new NFTContract().contractAddress)
        .from(NewTokenSeed)
        .whereIn("projectId", projects.map(x => x.projectId))
        .executeQuery();

    let idToProject = {};
    projects.forEach(proj => idToProject[proj.projectId] = proj);
    mints.forEach(
        mint => {
            if (!idToProject[mint.projectId].mints) {
                idToProject[mint.projectId].mints = [];
            }
            idToProject[mint.projectId].mints.push(mint);
        });
   
    return projects;
};


export const checkIfMinted = async (engine) => {
    let projects = await new BackendQuery(new NFTContract().contractAddress)
        .from(NewCreatorProject)
        .select("projectId")
        .select("title")
        .where("contentHash", engine.sequenceId)
        .executeQuery();

    let project = projects[0];
    if (!project) {
        // do nnothing
        return;
    }

    // otherwise look for all the mints

    let {projectId} = project;
    let mints = await new BackendQuery(new NFTContract().contractAddress)
        .from(NewTokenSeed)
        .where("projectId", projectId)
        .executeQuery();

    console.log(project);
    console.log("mintss", mints);

    mints = mints.map(x => ({... x, ...project}));
    mints.forEach(
        x => {
            x.projectId = x.projectId || 0;
            x.tokenId = x.tokenId || 0;
        });

    // so now that we knnow that some mints exist for this project
    // we need to set the redux so that the toolbar shows thi

    engine.dispatch(
        setMintedTokens(mints));

};


export const mintToken = async (projectId) => {
    if (window.ethereum) {
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        // Prompt user for account connections
        await provider.send("eth_requestAccounts", []);
        const signer = provider.getSigner();
        let {contractAddress, abi} = new NFTContract();
        const zcontract = new ethers.Contract(contractAddress, abi, signer);
        await zcontract.mint(projectId);
    }
};


export const loadMintedProject = async (engine, projectId, tokenId) => {
    console.log('loaded minted project =', projectId, tokenId);
    projectId = parseInt(projectId);
    tokenId = parseInt(tokenId);

    let project = await new BackendQuery(new NFTContract().contractAddress)
        .from(NewCreatorProject)
        .select("contentHash")
        .where("projectId", projectId)
        .executeQuery();

    let token = await new BackendQuery(new NFTContract().contractAddress)
        .from(NewTokenSeed)
        .select("seedHash")
        .where("tokenId", tokenId)
        .where("projectId", projectId)
        .executeQuery();

    if (token.length === 0 || project.length === 0) {
        // not found
        return;
    }
    token = token[0];
    project = project[0];

    engine.tokenId = tokenId;
    engine.projectId = projectId;
    engine.seedHash = token.seedHash;
    engine.loadSequence(project.contentHash);

    set_seed(token.seedHash);

    for (let i=0; i < 100; i++ ){
        console.log(value());
    }

    console.log("found the project+token pair", project, token);
};
